const normalizeDefs = (items) =>
  items.map((item) => (typeof item === 'string' ? { id: item, defaultSize: 'normal', defaultVisible: true } : item));

export function buildDefaultLayout(items) {
  return normalizeDefs(items).map((item) => ({
    id: item.id,
    visible: item.defaultVisible !== false,
    size: item.defaultSize || 'normal',
  }));
}

export function loadDashboardLayout(storageKey, items) {
  const defs = normalizeDefs(items);
  const widgetIds = defs.map((item) => item.id);
  const fallback = buildDefaultLayout(defs);

  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return fallback;

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return fallback;

    const normalized = [];
    const seen = new Set();

    for (const item of parsed) {
      if (!item || typeof item.id !== 'string' || !widgetIds.includes(item.id) || seen.has(item.id)) {
        continue;
      }
      const def = defs.find((entry) => entry.id === item.id);
      normalized.push({
        id: item.id,
        visible: item.visible !== false,
        size:
          item.size === 'wide' || item.size === 'normal'
            ? item.size
            : def?.defaultSize || 'normal',
      });
      seen.add(item.id);
    }

    for (const def of defs) {
      if (!seen.has(def.id)) {
        normalized.push({
          id: def.id,
          visible: def.defaultVisible !== false,
          size: def.defaultSize || 'normal',
        });
      }
    }

    return normalized;
  } catch (error) {
    console.error('Failed to load dashboard layout:', error);
    return fallback;
  }
}

export function saveDashboardLayout(storageKey, layout) {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(layout));
  } catch (error) {
    console.error('Failed to save dashboard layout:', error);
  }
}

export function toggleDashboardWidget(layout, targetId) {
  return layout.map((item) =>
    item.id === targetId ? { ...item, visible: !item.visible } : item
  );
}

export function moveDashboardWidget(layout, targetId, direction) {
  const index = layout.findIndex((item) => item.id === targetId);
  if (index < 0) return layout;

  const nextIndex = direction === 'up' ? index - 1 : index + 1;
  if (nextIndex < 0 || nextIndex >= layout.length) return layout;

  const nextLayout = [...layout];
  const [moved] = nextLayout.splice(index, 1);
  nextLayout.splice(nextIndex, 0, moved);
  return nextLayout;
}

export function cycleDashboardWidgetSize(layout, targetId) {
  return layout.map((item) =>
    item.id === targetId
      ? { ...item, size: item.size === 'wide' ? 'normal' : 'wide' }
      : item
  );
}
